import { useDebouncedValue } from "@mantine/hooks";
import { useEffect, useState } from "react";

import { SearchDriver, useLazySearchDriversQuery } from "@/store";

export type UseSearchDriversParams = {
  search?: string;
  getValue?: (driver: SearchDriver) => string;
  getLabel?: (driver: SearchDriver) => string;
};
export function useSearchDrivers({ search = "", getValue, getLabel }: UseSearchDriversParams = {}) {
  const [searchDriver, setSearchDriver] = useState(search);
  const [debouncedSearchDriver] = useDebouncedValue(searchDriver, 300);
  const [searchDrivers, { data: drivers, ...state }] = useLazySearchDriversQuery({
    selectFromResult: (state) => ({
      ...state,
      data: {
        options:
          state.data?.map((driver) => ({
            value: getValue?.(driver) || String(driver.id),
            label: getLabel?.(driver) || driver.name
          })) || [],
        result: state.data || []
      }
    })
  });

  useEffect(() => {
    if (debouncedSearchDriver.trim().length) {
      searchDrivers({ name: debouncedSearchDriver });
    }
  }, [debouncedSearchDriver, search]);

  return {
    data: drivers,
    actions: {
      setSearchDriver
    },
    state: {
      searchDriver,
      debouncedSearchDriver,
      ...state
    }
  };
}
